export const API_PATH = {
  urlMap: 'url_map',
  region: 'shop/region',
  city: 'shop/city',
  regionStatus: 'shop/region_status',
  cityStatus: 'shop/city_status',
  survey: {
    base: 'survey',
    detail: 'survey/detail',
    status: 'survey/status',
    clone: 'survey/clone',
  },
  surveyMapping: {
    base: 'shop/survey/restaurant_survey_map',
    status: 'shop/survey/restaurant_survey_map_status',
  },
}

export const ROUTER_PATH = {
  urlMap: '/url_map',
}
